// extracted by mini-css-extract-plugin
module.exports = {"modal":"ConsentModal_modal__30J7x"};